/*@flow*/

export default function isNil(x: any): %checks {
  return x === null || x === undefined;
}
